import React, { Component } from 'react'
import styled from 'styled-components'
import CheckboxAnswer from './CheckboxAnswer'

const OptionsContainer = styled.div`
    width: 100%
`

const OptionsHeader = styled.div`
  width: 100%;
  font-size: 12px;
  top: -10px;
  position: relative;
`

class QuestionMultipleChoiceOptions extends Component {
    onChange = option => {
      const { state } = this.props;
      const changed = state.map(x => x.index === option.index ? option : x)
      this.props.onChange(changed)
    }
    render() {
      const {
        state,
        ...restProps
      } = this.props
      return (
        <OptionsContainer>
          <OptionsHeader>
            List the multiple choice answer options - tick the correct answer(s)
          </OptionsHeader>
          {state && (
            state.map((option, i) => (
              <CheckboxAnswer state={option} onChange={this.onChange} />
            )
          ))}
        </OptionsContainer>
      )
    }
  }


export default QuestionMultipleChoiceOptions


// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/QuestionMultipleChoiceOptions.js